<template>
	<div class="panel_settlement">
		<div style="padding-top:7px;">
			<span class="priceItem" style="margin-right:20px;">
				<span class="label">现金卡合计：</span>
				<span class="price">￥{{total.cash}}</span>
			</span>
			<span class="priceItem" style="margin-right:120px;">
				<span class="label">
					现金卡折扣：
					<span v-if="$public.isNull(curActivity._id)">无折扣</span>
					<span v-else>
						{{$public.cheng(curActivity.discount,100)}}折（￥{{$public.cheng(curActivity.discount, total.cash)}}）
					</span>
				</span>
			</span>
			<span class="priceItem" style="margin-right:20px;">
				<span class="label">活体卡合计：</span>
				<span class="price">￥{{total.living}}</span>
			</span>
		</div>
		<div>
			<span class="priceItem" style="margin-right:20px;">
				<span class="label">应付：</span>
				<span class="price" style="color:#FF2F2F;">￥{{$public.jia(total.living, $public.cheng(curActivity.discount, total.cash))}}</span>
			</span>
			<span>
				
			</span>
			<el-button style="width:80px;" type="warning" plain @click="drawerRemark_state=true" size="small">备注</el-button>
			<el-button style="width:80px;" type="warning" @click="submitOrder" size="small">结算</el-button>
		</div>
		<!-- 备注弹窗 -->
		<div v-if="drawerRemark_state">
			<drawerRemark :type="'saleGiftCard'" @submit="drawerRemark_state=false"></drawerRemark>
		</div>
		<!-- 结算 -->
		<div v-if="dialogSettlement_state">
			<dialogSettlement :type="settlement_type" :orderId="curOrder._id" :canYue="false" @submit="dialogSettlementSubmit"></dialogSettlement>
		</div>
	</div>
</template>
<script>
	import dialogSettlement from "../../../../components/dialog_settlement.vue"
	import drawerRemark from "../drawer/remark.vue"
	export default {
		components:{dialogSettlement,drawerRemark,},
		data(){
			return{
				// 备注
				drawerRemark_state:false,
				// 活动
				curActivity:{},
				// 结算
				settlement_type:'order',
				dialogSettlement_state:false,
				curOrder:{},
				
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			saleList(){
				return this.$store.state.saleGiftCard.saleList;
			},
			total(){
				return this.$store.state.saleGiftCard.total;
			},
			remark(){
				return this.$store.state.saleGiftCard.remark;
			},
		},
		watch:{
			saleList(){
				this.getActivityList()
			}
		},
		mounted(){
			this.getActivityList()
		},
		methods:{
			// 创建订单
			submitOrder(){
				if(this.saleList.length>0){
					let cards = []
					let tableData = this.saleList;
					console.log('数据',tableData);
					for(let i=0;i<tableData.length;i++){
						if(this.$public.isNull(tableData[i].staff)&&tableData[i].card_type.value!=='2'){
							this.$message({
								message: '请选择销售人员',
								type: 'error'
							});
							return ;
						}
						cards.push({
							"cardNumber": tableData[i].card_number,
							"salesMans": tableData[i].staff.map(st=>{return {userId:st.split(',')[0],userName:st.split(',')[1]}}),
						})
					}
					let memberId = this.userInfo._id;
					let memberName = this.userInfo.basic_info.nick_name;
					let memberMobile = this.userInfo.basic_info.user_mobile;
					let params = {
						"memberId": memberId==="sankeId"?'':memberId,
						"order_platform": "web", 
						"memberName": memberName,
						"memberMobile": memberMobile,
						"remark": this.remark,
						"cards": cards,
					}
					console.log(params)
					let loading = this.$loading()
					this.$http.post('/api/Order/CreateGiftCardOrder', params).then(res => {
						loading.close();
						if (res.code == 0) {
							this.curOrder = res.data;
							this.dialogSettlement_state = true
						}
					})
				}
			},
			// 结算完成关闭弹窗
			dialogSettlementSubmit(a) {
				this.dialogSettlement_state = false;
				this.curActivity = {}
				this.$store.commit('saleGiftCard/reset')
				if(a=='close'){
					console.log('cancel')
				}else if(a=='fail'){
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				}else if(a=='success'){
					this.$message({
						message: '结算成功',
						type: 'success'
					});
				}
			},
			getActivityList(){
				if(this.total.cash===0){
					this.curActivity = {}
				}else{
					let params = {
						"page_index": 1,
						"page_size": 100,
						"keyword": "",
						"status": 1,
						"money": this.total.cash,
					}
					let loading = this.$loading()
					this.$http.post(process.env.VUE_APP_Activity+'/api/GiftCardActivity/GetList', params).then(res => {
						loading.close();
						if (res.code == 0) {
							this.curActivity = res.data.data?res.data.data[0]:{};
						}
					})
				}
			}
		}
	}
</script>
<style scoped lang="scss">
.panel_settlement{
	display: flex;
	justify-content: space-between;
	padding:10px 10px;
	background-color: #fff;
	box-shadow: 0 -3px 5px 0px #ccc;
	.priceItem{
		display: inline-flex;align-items: center;
		margin-right: 40px;
		.label{
			font-size: 14px;color:$fontColor;
		}
		.price{
			font-size: 20px;color:$fontColor;
		}
	}
}
</style>
